import { getLocalStorage } from "carynhealth-component-library/dist/cjs/helpers/storage";
import config from "../../config/constants/config";
const lang = getLocalStorage("Language");
const bannerProps = ({ isSmallScreen }: { isSmallScreen: boolean }) => {
  return {
    logo: {
      alt: "company brand",
      src: `/login/${
        config.APP_NAME === "NETWELL"
          ? "netwell-logo.png"
          : config.APP_NAME === "CURAMLIFE"
          ? "CuramLife_logo.png"
          : "uhs-logo.svg"
      }`,
      style: {},
    },
    banner: {
      alt: "company brand",
      src: `/login/${
        config.APP_NAME === "NETWELL"
          ? "netwell-banner-desktop.png"
          : config.APP_NAME === "CURAMLIFE"
          ? "curamlife_desktop.jpg"
          : isSmallScreen
          ? "uhf_banner_mobile.png"
          : "uhf_banner_desktop.png"
      }`,
      style: {},
    },
  };
};

export const awsConfig = {
  aws_project_region: process.env.REACT_APP_AWS_REGION,
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_cognito_identity_pool_id,
  aws_user_pools_id: process.env.REACT_APP_AWS_user_pools_id,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_user_pools_web_client_id,
  oauth: {},
};

export const authenticationProps = ({
  isSmallScreen,
}: {
  isSmallScreen: boolean;
}) => {
  return {
    config: "LOGIN",
    authCallback: () => {},
    awsConfig,
    appConfig: {
      sessionURL: process.env.REACT_APP_API_BASE_URL,
      tokenUserName: process.env.REACT_APP_GETWAY_TOKEN_USERNAME,
      tokenUserPassword: process.env.REACT_APP_GETWAY_TOKEN_PASS,
      brand: process.env.REACT_APP_ENV_NAME?.toLowerCase(),
    },
    bannerProps: bannerProps({ isSmallScreen }),
    language:lang
  };
};
